import { AppSpinner, Button } from '@one-snap/sparkles';
import { useTranslations } from 'next-intl';

import { Question } from './question';
import { ContactDetails } from './contact-details';
import { useGetContactInformationCommand } from 'lib/models/common/command/useGetContactInformationCommand';
import { useEffect, useState } from 'react';

export function HelpCenter() {
  const t = useTranslations('help');
  const contactInformation = useGetContactInformationCommand();
  const questions = [
    { faq: 'passwordChange', stepsImg: [false, false, false] },
    { faq: 'viewAgreement', stepsImg: [false, true, false] },
    { faq: 'linkDebitCard', stepsImg: [false, true, true] }
  ];
  const [helpData, setHelpData] = useState({});

  useEffect(() => {
    async function fetchData() {
      const response = await contactInformation.execute({});
      if (response.success && response.data) {
        setHelpData(response.data?.contactInformation);
      }
    }
    fetchData();
  }, []);

  if (contactInformation.executing) {
    <AppSpinner />;
  }

  return (
    <div className="bg-SnapWhite w-full p-6" data-testid="help-center">
      <div className="py-8 border-b-2 headingMHeavy md:headingL">
        {t('title')}
      </div>
      <div className="flex flex-col md:flex-row pl-5">
        <div className="md:basis-3/4">
          <div>
            <div className=" headingSHeavy md:headingMHeavy py-6">
              {t('commonQuestions.title')}
            </div>
            <div className="md:pr-64">
              {questions.map((question) => (
                <Question
                  key={question.faq}
                  faq={question.faq}
                  stepsImg={question.stepsImg}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="basis-1/4 flex flex-col content-center">
          <Button
            size="normal"
            variant="secondary"
            href={t('howItWorksLink')}
            className="my-4 mx-4"
            target="blank"
            reactlytics={{
              clickType: 'CTA',
              clickValue: t(`learnMoreBtnLabel`),
              placement: 'body'
            }}
          >
            {t(`learnMoreBtnLabel`)}
          </Button>
          <Button
            size="normal"
            variant="secondary"
            className="my-4 mx-4 headingMHeavy"
            aria-label={t('applyBtnLabel')}
            href={t('applyLink')}
            target="blank"
            reactlytics={{
              clickType: 'CTA',
              clickValue: t(`applyBtnLabel`),
              placement: 'body'
            }}
          >
            {t(`applyBtnLabel`)}
          </Button>
          <ContactDetails helpData={helpData} />
        </div>
      </div>
    </div>
  );
}
